const fit = [

    {label:"Tests done",
    controlType:"radio button",
    options:["1" , "2", ">2"],
    },

    {label:"Tests positive",
    controlType:"radio button",
    options:["1" , "2", ">2"],
    },

    
    {label:"Highest value (if known) ug/g",
    controlType:"number",
    options:[],
    },

    {label:"Date of most recent test",
    controlType:"date",
    options:[ ],
    },
    
    {label:"Lab where test performed:",
    controlType:"text",
    options:[ ],
    },
   
    
    {label:"Comments",
    controlType:"text area",
    options:[ ],
    },
    
    ]
    
    export default fit